import type { Dish, DishIngredient } from "@dashboard/types/dish";
import type { ReduxState } from "@dashboard/types/reduxState";

import { RestaurantSelectedAction } from "./restaurantReducer";

// This action is handled by both dish reducer and menu reducer
export type DeleteDishReducerAction = {
  type: "DELETE_DISH";
  payload: string[]; // payload is dishIds
};

export type DishReducerAction =
  | DeleteDishReducerAction
  | RestaurantSelectedAction
  | (
      | { type: "SET_DISH"; payload: Dish }
      | {
          type: "SET_DISH_INGREDIENTS";
          payload: {
            dishId: string;
            ingredients: DishIngredient[];
          }[];
        }
      | { type: "FETCHED_DISHES"; payload: Dish[] }
    ); // payload is dishes // payload is dishId, null means update errored or finished

export const dishReducer: (
  state: ReduxState["dish"] | undefined,
  action: DishReducerAction
) => ReduxState["dish"] = (
  state: ReduxState["dish"] = {
    initialDishesLoading: true,
    dishes: [],
  },
  action: DishReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_SELECTED":
      return {
        ...state,
        initialDishesLoading: true,
      };
    case "SET_DISH":
      // if the dish is already present, we update it
      // else we add it to the beginning.
      const dishIndex = state.dishes.findIndex(
        (dish) => dish.id === action.payload.id
      );

      if (dishIndex !== -1) {
        // update
        return {
          ...state,
          dishes: [
            ...state.dishes.slice(0, dishIndex),
            action.payload,
            ...state.dishes.slice(dishIndex + 1),
          ],
        };
      } else {
        // add
        return {
          ...state,
          dishes: [action.payload, ...state.dishes],
        };
      }
    case "SET_DISH_INGREDIENTS":
      return {
        ...state,
        dishes: state.dishes.map((dish) => {
          const dishToUpdate = action.payload.find((d) => d.dishId === dish.id);
          if (dishToUpdate) {
            return {
              ...dish,
              ingredients: dishToUpdate.ingredients,
            };
          } else {
            return dish;
          }
        }),
      };
    case "DELETE_DISH":
      return {
        ...state,
        dishes: state.dishes.filter(
          (dish) => !action.payload.includes(dish.id)
        ),
      };

    case "FETCHED_DISHES":
      return {
        ...state,
        initialDishesLoading: false,
        dishes: action.payload, // ordering is done in the action
      };
    default:
      return state;
  }
};
